import {
  IconUser,
  IconLock,
  IconShieldLock,
} from "@tabler/icons-react";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

export const TABS = [
  { id: "personal", label: "Personal Info", icon: IconUser },
  { id: "access", label: "Access & Role", icon: IconShieldLock },
  { id: "security", label: "Security", icon: IconLock },
];

export default function TabBar({ activeTab, onChange }) {
  return (
    <div className={styles.tabBar} role="tablist">
      {TABS.map(({ id, label, icon: Icon }) => {
        const isActive = activeTab === id;
        return (
          <button
            key={id}
            className={`${styles.tabBtn} ${isActive ? styles.tabBtnActive : ""}`}
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(id)}
          >
            <Icon size={16} />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
